export default "__VITE_ASSET__4bfae022__"